function LoginRedirectController($window: ng.IWindowService) {
  const url = $window.location.href.split('#')[1];
  let redirectUrl = '';
  if (url) redirectUrl = `#${url}`;

  $window.location.replace(`/login/${redirectUrl}`);
}

LoginRedirectController.$inject = ['$window'];

export default LoginRedirectController;
